import { toApiError } from '../../../lib/api-error';
import type { CanonicalPageDetailResponse } from './types';

type FetchCanonicalPageDetailOptions = {
  apiUrl: string;
  propertyId: string;
  canonicalPageId: string;
  credentialKey: string;
  fetchFn?: (input: string | URL | Request, init?: RequestInit) => Promise<Response>;
};

export function buildCanonicalPageDetailUrl({
  apiUrl,
  propertyId,
  canonicalPageId,
  credentialKey,
}: Omit<FetchCanonicalPageDetailOptions, 'fetchFn'>): string {
  const queryParams = new URLSearchParams();
  if (credentialKey) {
    queryParams.set('credentialId', credentialKey);
  }
  const path = `${apiUrl}/properties/${propertyId}/canonical-pages/${canonicalPageId}`;
  const query = queryParams.toString();
  return query ? `${path}?${query}` : path;
}

export async function fetchCanonicalPageDetail({
  apiUrl,
  propertyId,
  canonicalPageId,
  credentialKey,
  fetchFn = fetch,
}: FetchCanonicalPageDetailOptions): Promise<CanonicalPageDetailResponse> {
  const response = await fetchFn(
    buildCanonicalPageDetailUrl({ apiUrl, propertyId, canonicalPageId, credentialKey }),
    { credentials: 'include' }
  );
  if (!response.ok) {
    throw await toApiError(response, 'Failed to load canonical page');
  }
  return (await response.json()) as CanonicalPageDetailResponse;
}
